/* eslint-disable react/jsx-no-target-blank */
import React from "react";

import styles from "./JobCardLogo.module.scss"; // Import css modules stylesheet as styles

const NullLogo = (
    <svg width="29" height="37" viewBox="0 0 29 37" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_611_2508)">
            <path
                d="M28.5 35.0277C28.5 35.2929 28.3946 35.5473 28.2071 35.7348C28.0196 35.9223
                27.7652 36.0277 27.5 36.0277H14.5V1.9717C14.4999 1.78781 14.5504 1.60745 14.6461
                1.45043C14.7418 1.29341 14.879 1.16582 15.0425 1.08169C15.206 0.997558 15.3895
                0.96014 15.5729 0.973549C15.7563 0.986959 15.9325 1.05068 16.082 1.1577L28.082
                9.7297C28.2114 9.82232 28.3169 9.94451 28.3896 10.0861C28.4623 10.2277 28.5001
                10.3845 28.5 10.5437V35.0277Z"
                stroke="#767676"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M26.4995 8.60008V3.02808" stroke="#767676" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14.5 10.0282H18.5" stroke="#767676" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14.5 16.028H20.5" stroke="#767676" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M0.499756 22.028H6.49976" stroke="#767676" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M0.499756 28.0281H6.49976" stroke="#767676" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14.5 22.028H23.5" stroke="#767676" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M18.5002 36.0281V29.0281C18.5002 28.7629 18.6056 28.5085 18.7931 28.321C18.9807
                28.1334 19.235 28.0281 19.5002 28.0281H23.5002C23.7655 28.0281 24.0198 28.1334 24.2074
                28.321C24.3949 28.5085 24.5002 28.7629 24.5002 29.0281V36.0281"
                stroke="#767676"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.4998 16.028H1.49976C1.23454 16.028 0.980185 16.1333 0.792649 16.3208C0.605113 16.5084
                0.499756 16.7627 0.499756 17.028V35.028C0.499756 35.2932 0.605113 35.5475 0.792649 35.7351C0.980185
                35.9226 1.23454 36.028 1.49976 36.028H14.4998"
                stroke="#767676"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_611_2508">
                <rect width="29" height="37" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

interface JobCardLogoProps {
    showLogo: boolean;
    url: string;
    isLazy?: boolean;
}

/**
 * Renders a logo image for a job card, with the option to lazy load the image for better performance.
 */
const JobCardLogo = React.memo((props: JobCardLogoProps): JSX.Element => {
    const { showLogo, url, isLazy = true } = props;

    return (
        <div className={styles.logoContainer}>
            {
                (url && showLogo)
                    ? (
                        <img
                            className={styles.logoImage}
                            src={url}
                            alt=""
                            width="100"
                            height="100"
                            loading={isLazy ? "lazy" : "eager"}
                        />
                    )
                    : NullLogo
            }
        </div>
    );
});

JobCardLogo.displayName = "JobCardLogo";

export { JobCardLogo as default };
export type { JobCardLogoProps };
